import React from 'react';
import PropTypes from 'prop-types';

import DropdownMenu from '../../../../components/global/DropdownMenu';
import DotTrigger from '../../../../components/global/DotTrigger';

const propTypes = {
  dropdownProps: PropTypes.object,
  children: PropTypes.node,
};

const ListingCardThumbnailActionMenu = ({ children, ...props }) => {
  return (
    <div className="dropdown-menu-dark m-0">
      <DropdownMenu
        placement="bottom-end"
        toggle={<DotTrigger dotType="vertical" />}
        {...props}
      >
        {children}
      </DropdownMenu>
    </div>
  );
};

ListingCardThumbnailActionMenu.propTypes = propTypes;

export default ListingCardThumbnailActionMenu;
